import Select from 'react-select'
import React, {FC, useEffect, useState} from 'react'
import moment from 'moment-timezone'
import DatePicker from 'react-datepicker'
import ReactPaginate from 'react-paginate'
import {OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {MessageReportParams} from '../../../../../services/cellcast.v2.types'
import {useLoadedData} from '../../../../hooks/useGetLoadedData'
import NodataYet from '../../../../Components/NodataYet'

import {useGetUploadHistoriesQuery} from '../../../../../services/cellcast'
import {useGetUploadHistoriesQuery as useUploadHistory} from '../../../../../services/cellcast.v3'

import {Link} from 'react-router-dom'
import {defaultRegion, KTSVG} from '../../../../../_metronic/helpers'
import {RoutePaths} from '../../../../routing/RoutePath'
import clsx from 'clsx'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {UploadHistoryStatus} from '../../../../../services/cellcast.type'
import {UploadHistoryOptions} from '../../reports-analytics/Common'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useResponsive} from '../../../../hooks/useResponsive'
import {UploadHistoryMobileCard} from './components/UploadHistoryMobileCard'

interface UploadHistoryPageProps {
  newNavigation?: boolean // optional prop
}

const UploadHistory: FC<UploadHistoryPageProps> = ({ newNavigation }) => {
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const {calculate, loadedData, setLoadedData} = useLoadedData()
  const { isMobile } = useResponsive()
  // configure date range
  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([sevenDaysAgo, new Date()])
  const [startDate, endDate] = dateRange

  const [params, setParams] = useState<MessageReportParams>({
    fromDate: moment(sevenDaysAgo).format('YYYY-MM-DD'),
    toDate: moment(today).format('YYYY-MM-DD'),
    page: 1,
    limit: 10,
  })

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams

    if (endDate === null) {
      endDate = new Date()
    }

    setParams({
      ...params,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    })

    setDateRange(dateRangeParams)
  }

  const {
    data: dataV1,
    isLoading: isLoadingV1,
    isFetching: isFetchingV1,
  } = useGetUploadHistoriesQuery(params, {
    skip: !isDefaultRegion,
  })
  const {
    data: dataHistory,
    isLoading: isLoadingV2,
    isFetching: isFetchingV2,
  } = useUploadHistory(
    {
      action: 'find_upload_history',
      data: {
        ...params,
        limit: typeof params?.limit === 'string' ? parseInt(params?.limit) : params?.limit,
      },
    },
    {
      skip: isDefaultRegion,
    }
  )

  // Select data and loading states based on the condition
  const data = isDefaultRegion ? dataV1 : dataHistory
  const isLoading = isDefaultRegion ? isLoadingV1 : isLoadingV2
  const isFetching = isDefaultRegion ? isFetchingV1 : isFetchingV2

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data?.current ? data.data?.current : 1,
        params.limit,
        data && data.data?.total ? data.data?.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  return (
    <div>
      <div className='card'>
        <div className='card-header border-0 p-0 align-items-center'>
          <div className='d-flex flex-column w-100'>
            {!newNavigation ? (
              <h3 className='card-title align-items-start  flex-column'>
                <span className='card-label fw-bolder fs-2 mb-1'>Upload History</span>
                <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
              </h3>
            ) : null}
            <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'justify-content-end'}`}>
              <div className={isMobile ? 'w-100' : 'col-md-3'}>
                <div className='d-flex'>
                  <DatePicker
                    selectsRange={true}
                    dateFormat='MMM d, yyyy'
                    className=' border-0 form-control form-control-lg form-control-solid'
                    placeholderText='Pick data & time'
                    onChange={(update) => {
                      setDateParams(update)
                    }}
                    startDate={startDate}
                    endDate={endDate}
                    disabled={isLoading}
                  />
                  <span
                    className='input-group-text'
                    style={{backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa'}}
                  >
                    <i className='bi bi-calendar'></i>
                  </span>
                </div>
              </div>
              <div className={isMobile ? 'w-100' : 'ms-2 col-xs-4 col-md-3'}>
                <Select
                  options={UploadHistoryOptions}
                  onChange={(e) => {
                    setParams({...params, status: e?.value})
                  }}
                  isDisabled={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data?.items && data?.data?.items?.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                {/* Mobile view: Card layout */}
                {isMobile ? (
                  <div className='mobile-upload-history-list p-3'>
                    {isFetching ? (
                      <div className='text-center py-5'>
                        <Spinner />
                      </div>
                    ) : (
                      <>
                        {data?.data?.items?.map((item, i) => (
                          <UploadHistoryMobileCard key={item._id || i} item={item} />
                        ))}
                      </>
                    )}
                  </div>
                ) : (
                  /* Desktop view: Table layout */
                  <div className='table-responsive'>
                    <table className='table align-middle gs-0 gy-5 all-message-table'>
                      <thead>
                        <tr className='fw-400 text-muted'>
                          <th className='p-0 min-w-30px ps-3'>Filename</th>
                          <th className='p-0 min-w-30px ps-3'>Uploaded At</th>
                          <th className='p-0 min-w-30px ps-3'>Total Contact</th>
                          <th className='p-0 min-w-30px ps-3'>Imported Contact</th>
                          <th className='p-0 min-w-60px ps-3'>Duplicate Contact</th>
                          <th className='p-0 min-w-60px ps-3'>Invalid Contact</th>
                          <th className='p-0 min-w-60px ps-3'>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isFetching ? (
                          <tr>
                            <td colSpan={7} className='text-center'>
                              <Spinner />
                            </td>
                          </tr>
                        ) : (
                          <>
                            {data?.data?.items?.map((key, i) => {
                              const status = key?.status
                              const badgeClass = clsx({
                                'badge badge-light-success fw-bold': [
                                  UploadHistoryStatus.COMPLETED,
                                ].includes(status),
                                'badge badge-light-danger fw-bold': [
                                  UploadHistoryStatus.FAILED,
                                ].includes(status),
                                'badge badge-light-warning fw-bold': [
                                  UploadHistoryStatus.QUEUED,
                                ].includes(status),
                                'badge badge-light-primary fw-bold': [
                                  UploadHistoryStatus.INPROGRESS,
                                ].includes(status),
                              })

                              return (
                                <React.Fragment key={i}>
                                  <tr className='border-dashed border-2 border-bottom'>
                                    <td className='top-align'>
                                      {key?.originalName
                                        ? key.originalName
                                        : key?.filekey?.split('/').at(1) || '-'}
                                    </td>
                                    <td className='top-align'>
                                      {moment(key?.createdAt).format('l LT')}
                                    </td>
                                    <td className='top-align'>{key?.totalContact}</td>
                                    <td className='top-align'>{key?.importedContact}</td>
                                    <td className='top-align'>{key?.duplicatedContact || '-'}</td>
                                    <td className='top-align'>{key?.invalidContact}</td>
                                    <td className='top-align'>
                                      <span className={badgeClass}>{key?.status?.toUpperCase()}</span>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              )
                            })}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className={`abcd ${isMobile ? 'p-3' : ''}`}>
                  <select
                    onChange={(e: any) => {
                      setParams({...params, limit: e.target.value})
                    }}
                    value={params.limit || 10}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                        data.data.total ? data.data.total : 0
                      } data`}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={data?.data?.totalPages}
                    onPageChange={(e: any) => {
                      setParams({...params, page: e.selected + 1})
                    }}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <NodataYet message='No recent upload contacts history (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default UploadHistory
